<template>
  <v-row class="pl-md-3">
    <v-col cols="12">

      <v-card class="card-quote" elevation="0" style="min-height: 635px;">
        <v-card-text>
          <v-row class="px-5">
            <v-col cols="12" style="color: var(--v-darkblue-base); font-weight: bold; font-size: 16px;">
              <!-- <v-img src="img/icons/quote_contract_specifications.png" width="268" contain></v-img> -->
              <div
                class="d-flex flex-row align-center">
                <v-sheet
                  icon
                  color="title-icon"
                  class="d-flex justify-center align-center rounded-circle"
                  height="38"
                  width="38">
                  <v-icon color="title-icon-background" size="20">fas fa-file-alt</v-icon>
                </v-sheet>
                <span
                  class="title-foreground--text font-weight-medium ml-2">
                  Características do Contrato
                </span>
              </div>
            </v-col>

            <v-col cols="12" md="8">
              <v-row>
                <v-col cols="12" lg="6">

                  <v-row>
                    <v-col cols="12" class="subtitle component-col">
                      <span
                        class="foreground--text">
                        Para quem será o plano?
                      </span>
                    </v-col>

                    <v-col cols="12">
                      <v-switch
                        :readonly="iReadOnly"
                        v-model="allEmployees"
                        :value="true"
                        label="Todos os funcionários"
                        class="py-0 my-0 switch switch-base">
                      </v-switch>
                      <v-switch
                        :readonly="iReadOnly"
                        v-model="allEmployees"
                        :value="false"
                        label="Parte dos funcionários"
                        class="py-0 my-0 switch switch-base">
                      </v-switch>
                    </v-col>
                  </v-row>

                </v-col>

                <v-col cols="12" lg="6">

                  <v-row>
                    <v-col cols="12" class="subtitle component-col">
                      <span
                        class="foreground--text">
                        Coparticipação
                      </span>
                    </v-col>

                    <v-col cols="12">
                      <v-switch
                        :readonly="iReadOnly"
                        v-model="hasCopay"
                        :value="true"
                        label="Com coparticipação"
                        class="py-0 my-0 switch switch-base">
                      </v-switch>
                      <v-switch
                        :readonly="iReadOnly"
                        v-model="hasCopay"
                        :value="false"
                        label="Sem coparticipação"
                        class="py-0 my-0 switch switch-base">
                      </v-switch>
                    </v-col>
                  </v-row>

                </v-col>

              </v-row>

              <v-row>
                <v-col cols="12" lg="6">

                  <v-row>
                    <v-col cols="12" class="subtitle component-col">
                      <span
                        class="foreground--text">
                        Selecione o padrão de acomodação
                      </span>
                    </v-col>

                    <v-col cols="12">
                      <v-switch
                        :readonly="iReadOnly"
                        v-model="accommodations"
                        value="enf"
                        label="Enfermaria"
                        class="py-0 my-0 switch switch-base">
                      </v-switch>
                      <v-switch
                        :readonly="iReadOnly"
                        v-model="accommodations"
                        value="apt"
                        label="Apartamento"
                        class="py-0 my-0 switch switch-base">
                      </v-switch>
                      <v-switch
                        :readonly="iReadOnly"
                        v-model="accommodations"
                        value="N/A"
                        label="Sem Acomodação (Dental)"
                        class="py-0 my-0 switch switch-base">
                      </v-switch>
                    </v-col>
                  </v-row>

                </v-col>

                <v-col cols="12" lg="6">

                  <v-row>
                    <v-col cols="12" class="subtitle component-col">
                      <span
                        class="foreground--text">
                        Abrangência
                      </span>
                    </v-col>

                    <v-col cols="12">
                      <v-switch
                        :readonly="iReadOnly"
                        v-model="geographicScopes"
                        value="Nacional"
                        label="Nacional"
                        class="py-0 my-0 switch switch-base">
                      </v-switch>
                      <v-switch
                        :readonly="iReadOnly"
                        v-model="geographicScopes"
                        value="Regional"
                        label="Regional"
                        class="py-0 my-0 switch switch-base">
                      </v-switch>
                    </v-col>
                  </v-row>

                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="4">
              <v-row>
                <v-col cols="12" class="subtitle component-col">
                  <span
                    class="foreground--text">
                    Categoria de Plano
                  </span>
                </v-col>
                <v-col cols="12">
                  <v-switch
                    :readonly="iReadOnly"
                    v-model="planClassifications"
                    value="1"
                    label="Executivo"
                    class="py-0 my-0 switch switch-base">
                  </v-switch>
                  <v-switch
                    :readonly="iReadOnly"
                    v-model="planClassifications"
                    value="2"
                    label="Intermediáro"
                    class="py-0 my-0 switch switch-base">
                  </v-switch>
                  <v-switch
                    :readonly="iReadOnly"
                    v-model="planClassifications"
                    value="3"
                    label="Básico"
                    class="py-0 my-0 switch switch-base">
                  </v-switch>
                </v-col>
                
              </v-row>
            </v-col>
          </v-row>
          
          <v-row class="px-5">
            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="6">
              <v-row>
                <v-col cols="12" class="component-col-dual">
                  <p class="subtitle pb-0 mb-0 foreground--text">Hospitais</p>
                  <p class="caption foreground--text">Digite ou selecione seu(s) hospital(is) de preferência(s)</p>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    placeholder="Digite para buscar"
                    outlined
                    dense
                    multiple
                    chips
                    :readonly="iReadOnly"
                    :deletable-chips="!iReadOnly"
                    v-model="hospitalsSelecteds"
                    :items="hospitals"
                    item-text="xipp_commercial_name"
                    item-value="id"
                    :disabled="loadingHospitals"
                    :loading="loadingHospitals"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col col="12" md="6">
              <v-row>
                <v-col cols="12" class="component-col-dual">
                  <p class="subtitle pb-0 mb-0 foreground--text">Laboratórios</p>
                  <p class="caption foreground--text">Digite ou selecione seu(s) laboratório(s) de preferência(s)</p>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    placeholder="Digite para buscar"
                    outlined
                    dense
                    multiple
                    chips
                    :readonly="iReadOnly"
                    :deletable-chips="!iReadOnly"
                    v-model="laboratoriesSelecteds"
                    :items="laboratories"
                    item-text="xipp_commercial_name"
                    item-value="id"
                    :disabled="loadingLaboratories"
                    :loading="loadingLaboratories"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

    </v-col>
  </v-row>
</template>

<script>
import {mapActions, mapMutations} from "vuex";
import HospitalService from "@/services/odoo/HospitalService";
import LaboratoryService from "@/services/odoo/LaboratoryService";

export default {
  data: () => ({
    iReadOnly: false,
    allEmployees: [],
    hasCopay: [],
    accommodations: [],
    geographicScopes: [],
    planClassifications: [],
    loadingHospitals: false,
    loadingLaboratories: false,
    hospitals: [],
    laboratories: [],
    hospitalsSelecteds: [],
    laboratoriesSelecteds: [],
  }),
  watch: {
    allEmployees(newValue){
      if(newValue && newValue.length == 2 && newValue[0] != newValue[1]) {
        this.allEmployees = [];
        this.allEmployees.push(newValue[1]);
      }
      this.setContractFilterAllEmployees(this.allEmployees);
    },
    hospitalsSelecteds(newValue) {
      this.setHospitalsObj(newValue);
    },
    laboratoriesSelecteds(newValue) {
      this.setLaboratoriesObj(newValue);
    },
    hasCopay(newValue){
      if(newValue && newValue.length == 2 && newValue[0] != newValue[1]) {
        this.hasCopay = [];
        this.hasCopay.push(newValue[1]);
      }
      this.setContractFilterHasCopay(this.hasCopay);
    },
    accommodations(newValue) {
      this.setContractFilterAccommodations(newValue);
    },
    geographicScopes(newValue) {
      this.setContractFilterGeographicScopes(newValue);
    },
    planClassifications(newValue) {
      this.setContractFilterPlanClassifications(newValue);
    }
  },
  methods: {
    ...mapMutations(['showmsg']),
    ...mapActions(['setContractFilterAllEmployees', 'setContractFilterHasCopay', 'setContractFilterAccommodations', 
      'setContractFilterGeographicScopes', 'setContractFilterPlanClassifications', 'setHospitalsObj', 'setLaboratoriesObj']),
    clearFields() {
      this.allEmployees = [];
      this.hasCopay = [];
      this.accommodations = [];
      this.geographicScopes = [];
      this.planClassifications = [];
      this.hospitalsSelecteds = [];
      this.laboratoriesSelecteds = [];
      
      this.setContractFilterAllEmployees(this.allEmployees);
      this.setContractFilterHasCopay(this.hasCopay);
      this.setContractFilterAccommodations(this.accommodations);
      this.setContractFilterGeographicScopes(this.geographicScopes);
      this.setContractFilterPlanClassifications(this.planClassifications);
      this.setHospitalsObj(this.hospitalsSelecteds);
      this.setLaboratoriesObj(this.laboratoriesSelecteds);
    },
    loadAllActiveHospitals() {
      this.loadingHospitals = true;
      this._hospitalService.FindAllActive()
        .then(response => {
          if(response && response.data && response.data.records) {
            this.hospitals = response.data.records;
          }
        }).catch(() => {
          this.showmsg({text: 'Ocorreu um erro ao tentar carregar os hospitais.', type: 'error'});
        }).finally(() => {
          this.loadingHospitals = false;
        });
    },
    loadAllActiveLaboratories() {
      this.loadingLaboratories = true;
      this._laboratoryService.FindAllActive()
        .then(response => {
          if(response && response.data && response.data.records) {
            this.laboratories = response.data.records;
          }
        }).catch(() => {
          this.showmsg({text: 'Ocorreu um erro ao tentar carregar os laboratórios.', type: 'error'});
        }).finally(() => {
          this.loadingLaboratories = false;
        });
    },
    reloadDataFromSessionStorage() {
      const key = 'quoteDataObj';
      if (sessionStorage.getItem(key)) {
        const quoteData = JSON.parse(atob(sessionStorage.getItem(key)));
        const planFilters = quoteData ? quoteData.planFiltersObj : null;

        this.accommodations = planFilters && planFilters.accommodations ? JSON.parse(JSON.stringify(planFilters.accommodations)) : [];
        this.geographicScopes = planFilters && planFilters.geographicScopes ? JSON.parse(JSON.stringify(planFilters.geographicScopes)) : [];
        this.allEmployees = planFilters && planFilters.allEmployees ? JSON.parse(JSON.stringify(planFilters.allEmployees)) : [];
        this.hasCopay = planFilters && planFilters.hasCopay ? JSON.parse(JSON.stringify(planFilters.hasCopay)) : [];
        this.planClassifications = planFilters && planFilters.planClassifications ? JSON.parse(JSON.stringify(planFilters.planClassifications)) : [];
        
        this.hospitalsSelecteds = planFilters && planFilters.hospitalsObj ? JSON.parse(JSON.stringify(planFilters.hospitalsObj)) : [];
        this.laboratoriesSelecteds = planFilters && planFilters.laboratoriesObj ? JSON.parse(JSON.stringify(planFilters.laboratoriesObj)) : [];
      }
    }
  },
  computed: {
  },
  beforeCreate() {
    this._hospitalService = new HospitalService();
    this._laboratoryService = new LaboratoryService();
  },
  created() {
    this.iReadOnly = this.$route.query.detail && (this.$route.query.detail === true || this.$route.query.detail === 'true');
    this.loadAllActiveHospitals();
    this.loadAllActiveLaboratories();
    this.reloadDataFromSessionStorage();
  },
};
</script>

<style scoped>
.component-col {
  height: 40px !important;
}

.component-col-dual {
  height: 65px !important;
}

.subtitle {
  color: black;;
  font-weight: bold;
}

.switch {
  height: 40px;
}

@media only screen and (min-width: 960px) and (max-width: 1000px) {
  .subtitle {
    margin-bottom: 25px;
  }
}
</style>
